import {createContext, useContext} from 'react';

import {Unregistrator} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {ContextOf} from '../../applications/bridge/v2/types/bridgeTypesV2';
import {LegacyEntryPointModel} from '../../models/api/legacyEntryPointModel';

/*
 * Props.
 */

export interface LegacyApplicationsContextProps {
  findSendContext<TEntryPoint extends LegacyEntryPointModel>(
    applicationId: number,
  ): ((context: ContextOf<TEntryPoint['type']>) => Unregistrator) | undefined;
}

/*
 * Context.
 */

const LegacyApplicationsContext = createContext<LegacyApplicationsContextProps>({
  findSendContext: () => () => () => {},
});

export const LegacyApplicationsContextProvider = LegacyApplicationsContext.Provider;

/*
 * Hook.
 */

export function useApplications() {
  return useContext(LegacyApplicationsContext);
}
